import React, { Component } from 'react';
import {
  staticMedalData
} from './staticData.js';

import './medal.scss';

class Medal extends Component {
  constructor(props, context){
    super(props)
    this.state = {
      
    }
  }
  getUserMedalStatus(medalData, data) {
    // 处理数据，通过接口返回的unlock字段控制用户徽章是否被点亮
    for (let i = 0; i < medalData.length; i++) {
      for (let n = 0; n < medalData[i].length; n++) {
        if (data.id === medalData[i][n].id) {
          if (this.props.dark) {
            return medalData[i][n].unlock ? <img src={data.dartUnlockImage} /> : <img src={data.darklockImage} />
          } else {
            return medalData[i][n].unlock ?  <img src={data.lightUnlockImage} /> : <img src={data.lightlockImage} />
          }
        }
      }
    }
  }
  dredgeStatus(item) {
    if (item.dredge) {
      return <img src={item.dredgeImg} /> ;
    }
    return <img src={item.notDredgeImg} /> ;
  }
  render() {
    const medalData = this.props.medalData
    var getMedalMany = 0
    for (let i = 0; i < medalData.length; i++) {
      for (let n = 0; n < medalData[i].length; n++) {
        if (medalData[i][n].unlock) {
          getMedalMany = getMedalMany + 1
        }
      }
    }
    return (
      <div className="medal">
        <h5 className="color-text-1">特别奖章<span className="color-text-dismiss">{getMedalMany}个</span></h5>
        {
          staticMedalData && staticMedalData.map((item, index) =>
            <ul key={index.toString()}>
              {
                item && item.map((itm, idx) => 
                  <li key={idx} data={itm}>
                    {
                      this.getUserMedalStatus(this.props.medalData, itm)
                    }
                    <p className="color-text-1">{itm.title}</p>
                    <span className="color-text-3">{itm.desc}</span>
                  </li> 
                )
              }
            </ul>
          )
        }
      </div>
    );
  }
}

export default Medal;
